import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';

// Hashed assets from a previous deploy disappear after a rollout; when a
// lazy route's chunk/CSS preload fails in an open tab, reload to pick up the
// new build instead of crashing into the router error screen.
//
// The guard is a cooldown rather than a one-shot flag: staff keep this app
// open across several deploys a day, and a boolean spends its single recovery
// on the first one, then leaves them stranded on the error screen for the rest
// of the session. A genuine reload loop still stops after one attempt, because
// each iteration lands far inside the cooldown.
const PRELOAD_RELOAD_COOLDOWN_MS = 10_000;

window.addEventListener('vite:preloadError', (event) => {
  const reload_key = 'auth_preload_error_reloaded_at';
  const last_reload_at = Number(sessionStorage.getItem(reload_key) ?? '0');
  if (Date.now() - last_reload_at < PRELOAD_RELOAD_COOLDOWN_MS) {
    return;
  }
  sessionStorage.setItem(reload_key, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

const root_element = document.getElementById('root');
if (root_element === null) {
  throw new Error('root element not found in index.html');
}

createRoot(root_element).render(
  <StrictMode>
    <App />
  </StrictMode>
);
